import { uiFormButtonComponent } from './form-button.component';
import onLongPress from './plugins/onLongPress';
import vButton from './plugins/v-button';

export default angular
  .module('ng1-form-button', [onLongPress, vButton])
  .component('fdFormButton', uiFormButtonComponent)
  .name;
